import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { cn } from "~/lib/utils";

type AddButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
};

export const AddButton = ({ onClick, disabled, className }: AddButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={cn(
      "flex h-16 w-16 items-center justify-center rounded-full bg-kiosk-text-white text-2xl text-kiosk-text-primary shadow-md",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
  >
    <FontAwesomeIcon icon={faPlus} />
  </button>
);
